// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavItem_navItem__i92AA","pressed":"NavItem_pressed__oeOBk","navItemText":"NavItem_navItemText__lD5K9"};